module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetLow.906c4f9.webp";